import { isEmpty, isNil, trim } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';

export const isNullOrUndefined = (value: any): boolean => isNil(value);

export const isNullOrUndefinedOrEmpty = (value: any): boolean => isNullOrUndefined(value) || isEmpty(value);

export const isNotEmpty = (value?: string): boolean => !isNullOrUndefinedOrEmpty(value) && value !== '';

export const isBlank = (value?: string | null) => isNil(value) || value === '' || Boolean(value && !trim(value).length);

export const trimValue = (value: string) => {
  return checkEmptyValue(value).replace(/^[\s\u3000]+|[\s\u3000]+$/g, '');
};

export function checkEmptyValue<T>(value?: T | null): string {
  return isNullOrUndefined(value) ? '' : String(value);
}

/**
 * Generates a random UUID (UUID4).
 * @returns {string} A random UUID.
 */
export const generateRandomUuid = (): string => {
  return uuidv4();
};

/**
 * Replaces all sequences of whitespace characters in the input text with newline characters.
 * @param {string} text - The input text to process.
 * @returns {string} The processed text with whitespace replaced by newlines.
 */
export function breakLinesOnWhitespace(text?: string): string {
  if (!text) return '';
  return text.replaceAll(/\s+/g, '\n');
}
